export const footer = {
  footerTitleGame: "Die beste speletjies",
  footerTitleGameCasino: "Casino",
  footerTitleGameLottery: "Lotery",
  footerTitleGameGames: "Speletjies",
  footerTitleSports: "Sport",
  footerTitleGameSlots: "Slots",
  footerTitleGameMinigame: "Mini-speletjies",
  footerTitleTestimonials: "Getuienisse",
  footerTitleNews: "Nuus",
  footerTitleLiga: "Wenligas",
  footerTitleLigaEsports: "E-Sport",
  footerTitleLigaLeague: "Die liga",
  footerTitleLigaFootball: "UEFA Kampioeneliga",
  footerTitleSupport: "Ondersteuning",
  footerTitleHelp: "Helpersentrum",
  footerTitleTerms: "Bepalings en voorwaardes",
  footerTitleSocial: "Volg ons",
  footerTitleApp: "Laai ons toep af",
  footerTitlePromotions: "Promosies",
  footerTitleResponsibleGambling: "Dobbel verantwoordelik. Slegs vir 18+.",
  footerTitleSafeGame: "Alles vir 'n veiliger spel",
  footerInfoTitle: "Inligting",
  footerCategoriesTitle: "Kategorieë",
  footerContactSupport: "Gesels met ons",
  footerSupportDesc: "Vrae? Ons is hier.",
  footerPromoTitle: "Gratis spelinkies!",
  footerPromoDesc: "1 gratis spelin vir elke R 40 op jou eerste deposito",
  footerPromoAvailable: "Beskikbaar vir Android en iOS",
  footerWinAppTitle: "Laai die Windows-toep af en speel op jou rekenaar",
  footerInstallBtn: "Installeer",
  footerRegisterBtn: "Teken in",
  footerGPlayTitle: "Laai van Google Play af",
  footerGPlayDesc: "Die beste speelervaring op jou Android",
  footerIOSTitle: "Laai van die App Store af",
  footerIOSDesc: "Beskikbaar vir iPhone en iPad",
  footerDownloadBtn: "Laai af",
  footerGetItOn: "KRY DIT OP",
  footerDownloadOn: "Laai af op die",
};
